import { render, staticRenderFns } from "./CollectionLayoutBlocks.vue?vue&type=template&id=59ec6db6&lang=pug&"
import script from "./CollectionLayoutBlocks.vue?vue&type=script&lang=js&"
export * from "./CollectionLayoutBlocks.vue?vue&type=script&lang=js&"
import style0 from "./CollectionLayoutBlocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ec6db6')) {
      api.createRecord('59ec6db6', component.options)
    } else {
      api.reload('59ec6db6', component.options)
    }
    module.hot.accept("./CollectionLayoutBlocks.vue?vue&type=template&id=59ec6db6&lang=pug&", function () {
      api.rerender('59ec6db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/CollectionLayoutBlocks.vue"
export default component.exports